import { Box, Button, Snackbar, TextField, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { fieldStyle } from '../../../../../../../core/global/realproperty/Index';
import IconButton from '@mui/material/IconButton';
// import CloseIcon from '@mui/icons-material/Close';
import { Check } from '@mui/icons-material';


export const SiteIdentity = ({ errors, showPicker, togglePicker, templateForm, handleChange, pickerRef, company_id }) => {
    const form = templateForm.data;
    const fileHandler = (f, e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const u = { ...templateForm.data };
            u[f] = { value: file, object: URL.createObjectURL(file), name: file.name, type: file.type.split('/')[1], size: file.size, updated: true };
            templateForm.set({ ...templateForm.data, logo: u.logo });
        };
        reader.readAsDataURL(file);
    };
    const handleRemoveLogo = () => {
        const u = { ...form };
        u.logo = { value: null, object: null, name: '', type: '', size: 0, updated: false, stat: false, msg: '', };
        templateForm.set({ ...templateForm.data, logo: u.logo });
    };
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const isValidURL = (l) => {
        try {
            new URL(l);
            if (l.includes("://") && l.split("://")[1].includes("//")) {
                return false;
            }
            return true;
        } catch (error) {
            return false;
        }
    };
    const handleCopyLink = async () => {
        const link = `${process.env.REACT_APP_URL_SHP}/psl/ws/realproperty/${window.btoa(`${company_id}`)}_${window.btoa(`${form.id}`)}?type=property-rent`;
    
        // Validate website link before copying
        if (!isValidURL(link)) {
            templateForm.set((prevForm) => ({
                ...prevForm,
                website_link: {
                    ...prevForm.website_link,
                    stat: true,
                    msg: "Invalid website link format!",
                },
            }));
            return;
        }
        try {
            await navigator.clipboard.writeText(link);
            setSnackbarOpen(true);
            setTimeout(() => {
                setSnackbarOpen(false);
            }, 2000);
        } catch (error) {
            console.error("Failed to copy:", error);
        }
    };
    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="primary"
                onClick={() => setSnackbarOpen(false)}
            >
                <Check fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const classes = fieldStyle()
    return (
        <Box height="100%" width="100%" display="flex" alignItems="center" flexDirection="column" p={2} mb={5}>
            <Box width="100%">
                <Typography variant="h7" mb={1}>
                    Logo
                </Typography>
                <Box display="flex" alignItems="center" flexDirection="column">
                    <Box width="100%" height={120}
                        border={`1px dashed ${errors.logo === true && form.logo.value === undefined ? 'red' : "#757c84"}`}
                        borderRadius={1} display="flex" justifyContent="center" alignItems="center" sx={{ backgroundColor: 'grey.100' }}>
                        {form.logo.object ?
                            (<img src={form.logo.object} alt="Uploaded logo" style={{ maxHeight: '100%', maxWidth: '100%', padding: "8px" }} />)
                            :
                            (
                                <Box flexDirection="column" alignItems="center">
                                    <Typography variant="body2" color="text.secondary">Upload your logo</Typography>
                                    <Box mt={1} fontSize={14} color="red">{errors.logo === true && form.logo.value === undefined && 'Logo is required'}</Box>
                                </Box>
                            )}
                    </Box>
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        <Button variant="outlined" sx={{ borderRadius: 2 }} onClick={handleRemoveLogo} disabled={!form.logo.object}>
                            Remove
                        </Button>
                        <Button component="label" variant="contained" sx={{ borderRadius: 2 }}>
                            {form.logo.value === undefined ? 'Upload' : 'Change'}
                            <input type="file" accept="image/*" hidden onChange={(e) => fileHandler('logo', e)} />
                        </Button>
                    </Box>
                </Box>
            </Box>
            <Box my={3}>
                <Typography variant="h7" mb={1}>
                    Site Title
                </Typography>
                <TextField size="small" fullWidth onChange={(e) => handleChange(e)} name='top.title' value={form.top.title.value} error={form.top.title.stat} helperText={form.top.title.msg}
                    // sx={{ bgcolor: "#fff", borderRadius: 1 }}
                    className={classes.tf}
                />
            </Box>
            <Box width="100%" mb={3} >
                <Typography variant="h7" mb={1}>
                    Header Background Color
                </Typography>
                <Box display="flex" alignItems="center" gap={3} mt={1} >
                    <Tooltip title='Header Color'>
                        <Box width={50} >
                            <Box display="flex" alignItems="center" flexDirection='column'>
                                <Box
                                    onClick={() => togglePicker('for-header-bgcolor')}
                                    width={30} height={30} border={`1px solid ${form.top.bg_color}`} borderRadius={1}
                                    sx={{ bgcolor: form.top.bg_color, cursor: 'pointer', ':hover': { bgcolor: form.top.bg_color, color: '#fff' }, }}
                                />
                                <Box bgcolor='#fff' px={1} mt={0.5} fontSize={11} >{form.top.bg_color}</Box>
                            </Box>
                        </Box>
                    </Tooltip>
                    {/* <Tooltip title='Button Color'>
                        <Box width={50} >
                            <Box display="flex" alignItems="center" flexDirection='column'>
                                <Box
                                    onClick={() => togglePicker('for-header-btncolor')}
                                    width={30} p={1} height={30} border={`1px solid ${form.top.buttons.bg}`} borderRadius={1}
                                    sx={{ bgcolor: form.top.buttons.bg, cursor: 'pointer', ':hover': { bgcolor: form.top.buttons.bg, color: '#fff' }, }}
                                />
                            </Box>
                            <Box bgcolor='#fff' px={1} mt={0.5} fontSize={11}>{form.top.buttons.bg}</Box>
                        </Box>
                    </Tooltip> */}
                </Box>
                <Box height="100%">
                    {showPicker.data.header.bg && (
                        <Box width="100%" height="100%" ref={pickerRef} pt={1}>
                            <SketchPicker
                                color={form.top.bg_color}
                                onChangeComplete={(color) => handleChange({
                                    target: { name: 'top.bg_color', value: color.hex }

                                })}
                            />
                        </Box>
                    )}
                    {showPicker.data.header.btn.bg && (
                        <Box width="100%" height="100%" pt={1} ref={pickerRef}>
                            <SketchPicker
                                color={form.top.buttons.bg}
                                onChangeComplete={(color) => handleChange({
                                    target: { name: 'top.buttons.bg', value: color.hex }

                                })}
                            />
                        </Box>
                    )}

                </Box>
            </Box>
            <Box width="100%" >
                <Typography variant="h6" mb={1}>
                Website Link
                </Typography>
                <TextField size="small" fullWidth className={classes.tf}
                    //onChange={(e) => handleChange(e)}
                    name="website_link"
                    //value={form.website_link.value}
                    defaultValue={`${process.env.REACT_APP_URL_SHP}/psl/ws/realproperty/${window.btoa(`${company_id}`)}_${window.btoa(`${form.id}`)}?type=property-rent`}
                    error={form.website_link.stat}
                    helperText={form.website_link.msg}
                    disabled
                />
                {form.id !== "" &&
                    <>
                        <Button
                            variant="outlined"
                            sx={{ borderRadius: 2, mt: 1, width: 100 }}
                            onClick={handleCopyLink}
                        >
                            {snackbarOpen ? "Copied!" : "Copy Link"}
                        </Button>

                        <Box mt={1} width="100%">
                            <Typography borderRadius={1} fontSize={12} p={1} sx={{ wordBreak: "break-word" }}
                                bgcolor={snackbarOpen ? "#8a8c8e" : false}
                                color={snackbarOpen ? "green" : "#64696e"}>
                                {/* {`${process.env.REACT_APP_URL_SHP}/psl/${form.website_link.value}/${window.btoa(`${company_id}`)}_${window.btoa(`${form.id}`)}?type=property-rent`} */}
                                {`${process.env.REACT_APP_URL_SHP}/psl/ws/realproperty/${window.btoa(`${company_id}`)}_${window.btoa(`${form.id}`)}?type=property-rent`}
                            </Typography>
                        </Box>
                    </>
                }
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    message="Link Copied"
                    action={action}
                    sx={{ "& .MuiSnackbarContent-root": { backgroundColor: "#9B9B9B", color: "green", ml: 26, bottom: 0 } }}

                />
            </Box>

        </Box>
    );
};